import Tooltip from '~/components/RedesignedTooltip';
import QuestionIcon from '~/images/QuestionIcon.svg';

export default function InputLabelTooltip({ title, style }) {
  return (
    <Tooltip
      title={title}
      style={{
        cursor: 'pointer',
        position: 'relative',
        left: 5,
        marginRight: 8,
        ...style,
      }}>
      <QuestionIcon />
    </Tooltip>
  );
}

InputLabelTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  style: PropTypes.object,
};
